export const ACTIONS_TYPES = {
  floating: 'floating',
  content: 'content',
};
